// extracted by mini-css-extract-plugin
export default {"upload":"upload---Rphoo","uploadTitle":"uploadTitle---wxeep","activeUpload":"activeUpload---aR6Zp","activeUploadTitle":"activeUploadTitle---DzSTi"};